"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedPlayers = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const design_player_avatar_1 = require("@unboared/design.player.avatar");
const design_player_player_1 = require("@unboared/design.player.player");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const base_ui_text_text_1 = require("@unboared/base-ui.text.text");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
function ConnectedPlayers({ style, players, masterID, maxDisplay = 1000, size = design_player_avatar_1.DEFAULT_AVATAR_SIZE, short, title }) {
    const playersToDisplay = players.slice(0, Math.min(players.length, maxDisplay));
    const numOtherPlayers = players.length - playersToDisplay.length;
    if (short) {
        return react_1.default.createElement(ShortConnectedPlayers, { playersToDisplay: playersToDisplay, numOtherPlayers: numOtherPlayers, size: size });
    }
    return react_1.default.createElement(FullConnectedPlayers, { style: style, playersToDisplay: playersToDisplay, numOtherPlayers: numOtherPlayers, masterID: masterID, size: size, title: title });
}
exports.ConnectedPlayers = ConnectedPlayers;
const FullConnectedPlayers = ({ playersToDisplay, numOtherPlayers, size, masterID, title, style }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    return (react_1.default.createElement(react_native_1.View, { style: style },
        title && react_1.default.createElement(base_ui_text_text_1.Text, { style: { marginBottom: normalize(base_ui_theme_spacing_1.space.tiny), fontWeight: 'bold' }, text: title }),
        react_1.default.createElement(react_native_1.FlatList, { style: { flex: 1 }, data: playersToDisplay, renderItem: ({ item }) => react_1.default.createElement(react_native_1.View, { style: { alignItems: 'flex-start', marginVertical: normalize(base_ui_theme_spacing_1.space.tiny) } },
                react_1.default.createElement(design_player_player_1.Player, { avatar: item.avatar, username: item.username, color: item.color, master: item.uid === masterID, size: size })), keyExtractor: item => item.uid, showsVerticalScrollIndicator: false, showsHorizontalScrollIndicator: false }),
        numOtherPlayers > 0
            && react_1.default.createElement(react_native_1.View, { style: { alignItems: 'flex-start', marginVertical: normalize(base_ui_theme_spacing_1.space.tiny) } },
                react_1.default.createElement(design_player_avatar_1.AdditionalPlayerIcon, { num: numOtherPlayers, size: size }))));
};
const ShortConnectedPlayers = ({ playersToDisplay, numOtherPlayers, size }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    return (react_1.default.createElement(react_native_1.View, { style: stylesShort.container },
        playersToDisplay.map((player, index) => (react_1.default.createElement(react_native_1.View, { key: index, style: Object.assign({}, stylesShort.player, { left: -normalize(0.5 * size * index) }) },
            react_1.default.createElement(design_player_avatar_1.Avatar, { name: player.avatar, color: player.color, size: size, border: true })))),
        numOtherPlayers > 0 &&
            react_1.default.createElement(react_native_1.View, { style: { left: -normalize(0.5 * size * playersToDisplay.length) } },
                react_1.default.createElement(design_player_avatar_1.AdditionalPlayerIcon, { num: numOtherPlayers, size: size, border: true }))));
};
const stylesShort = react_native_1.StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'row',
    },
    player: {
        position: 'relative',
    },
});
//# sourceMappingURL=connected_players.js.map